import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    AvnetAbacusV3CredentialsInputDTORuntype,
    AvnetAbacusV3ResponseBodyDTORuntype,
} from './avnetAbacusV3BackendTypes';

export const avnetAbacusV3Endpoints = {
    'GET /3rdparty/avnetabacusv3/credentials': endpoint({
        description: 'Returns credentials for Avnet Abacus V3 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: AvnetAbacusV3ResponseBodyDTORuntype,
    }),
    'POST /3rdparty/avnetabacusv3/credentials': endpoint({
        description: 'Uploads credentials for Avnet Abacus V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetAbacusV3CredentialsInputDTORuntype,
        responseBody: AvnetAbacusV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetabacusv3/credentials'],
    }),
    'PATCH /3rdparty/avnetabacusv3/credentials': endpoint({
        description: 'Updates credentials for Avnet Abacus V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetAbacusV3CredentialsInputDTORuntype,
        responseBody: AvnetAbacusV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetabacusv3/credentials'],
    }),
    'DELETE /3rdparty/avnetabacusv3/credentials': endpoint({
        description: 'Deletes existing credentials for Avnet Abacus V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/avnetabacusv3/credentials'],
    }),
};
